import { Functions } from '../functions'

export default {
    getLocale: state => {
        return state.locale
    },
    getCurrency: state => {
        return state.currency
    },
    getLoading: state => {
        return state.loading
    },
    getShowLots: state => {
        return state.showLots
    },
    getUser: state => {
        return state.user
    },
    getAuction: state => {
        return state.auction
    },
    getLot: state => {
        if(! state.lot) return null
        const lot = state.lots.find(item => {
            return item.id == state.lot
        })
        return lot
    },
    getLots: state => {
        return state.lots
    },
    getSelectedLot: state => {
        if(! state.selectedLot) return null
        const lot = state.lots.find(item => {
            return item.id == state.selectedLot
        })
        return lot
    },
    getNextLot: state => {
        if(state.selectedLot) {
            let i = state.lots.findIndex(item => {
                return item.id == state.selectedLot
            })
            if(state.lots[i+1]) {
                return state.lots[i+1]
            } else {
                return null
            }
        } else if (state.lot) {
            let i = state.lots.findIndex(item => {
                return item.id == state.lot
            })
            if(state.lots[i+1]) {
                return state.lots[i+1]
            } else {
                return null
            }
        } else {
            return null
        }
    },
    getBidders: state => {
        return state.bidders
    },
    getBids: state => {
        return state.bids
    },
    getWinner: state => {
        return state.winner
    },
    getIsHighestBidder: state => {
        if(! state.user) return false
        if(! state.user.id) return false
        if(! state.winner) return false
        if(! state.winner.uid) return false
        if(state.winner.uid === state.user.id) {
            return true
        } else {
            return false
        }
    },
    getIsWinner: state => {
        return true
    },
    getIsBidder: state => {
        if(! state.user) return false
        if(! Array.isArray(state.bids)) return false
        if(state.bids.length == 0) return false
        return state.bids.filter(el => el.uid == state.user.id).length > 0
    },
    getWarn: state => state.warn,
    getNext5Steps: (state, getters) => {
        let lot = getters.getLot
        if(! lot) return []

        let step = lot.k
        let steps = []
        for(var i=1; i<=5; i++) {
            step = Functions.getNextStep(lot.i, step)
            steps.push(step)
        }
        return steps
    },
    getNext10Steps: (state, getters) => {
        let lot = getters.getLot
        if(! lot) return []

        let step = lot.k
        let steps = []
        for(var i=1; i<=10; i++) {
            step = Functions.getNextStep(lot.i, step)
            steps.push(step)
        }
        return steps
    },
    getNext20Steps: (state, getters) => {
        let lot = getters.getLot
        if(! lot) return []

        let step = lot.k
        let steps = []
        for(var i=1; i<=20; i++) {
            step = Functions.getNextStep(lot.i, step)
            steps.push(step)
        }
        return steps
    },
    getMessages: state => {
        return state.messages
    },
    getTimer: state => {
        return state.timer
    },
    getRecallTimer: state => {
        return state.recallTimer
    },
    getAudioEnabled: state => {
        return state.audioEnabled
    },
    getAudioBlocked: state => {
        return state.audioBlocked
    },
    getAudioQueue: state => {
        return state.audioQueue
    },
    getActiveAnnouncement: state => {
        return state.activeAnnouncement
    },
}
